import styled from "styled-components";
import { colors } from "globalStyles";
import { media } from "utils/style-utils";

export const Title = styled.span`
  color: ${colors.BODY};
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
`;

export const TitleWrapper = styled.div`
  text-align: center;
  padding-top: 15px;
`;

export const Content = styled.div`
  padding: ${({ tinyModal }) => (tinyModal ? "25px" : "50px")};
  min-height: ${({ tinyModal }) => (tinyModal ? "180px" : "372px")};
  ${media.mobile`
     padding: 25px;
  `}
`;

export const Button = styled.button`
  position: absolute;
  padding: 18px 18px 0;

  > svg {
    fill: ${colors.BODY};
  }
`;
